"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _merge = _interopRequireDefault(require("./util/merge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var defaults = {
  api: '',
  format_date: function format_date(date) {
    return new Intl.DateTimeFormat('en-GB', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    }).format(date);
  }
};

var Config = /*#__PURE__*/function () {
  function Config(config) {
    _classCallCheck(this, Config);

    this.config = (0, _merge["default"])(defaults, config);
  }

  _createClass(Config, [{
    key: "all",
    value: function all() {
      return this.config;
    }
  }, {
    key: "get",
    value: function get(propertyPath) {
      var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return propertyPath.split('.').reduce(function (prev, curr) {
        return prev ? prev[curr] : undefined;
      }, this.config) || def;
    }
  }]);

  return Config;
}();

exports["default"] = Config;